import React, { useContext, useState } from 'react';
import {
    humanFriendlyPageMap,
    getPageFAIUrl,
    getPageInstitutionalUrl,
    getFundFAIUrl,
    getFundInstitutionalUrl
} from './util';
import { ReactTargetContext } from '../ReactTarget/ReactTarget';
import { isLowerEnvironment } from '../../config';
import styles from './FaiCTA.css';

const LOCAL_STORAGE_NAMESPACE = 'trp_fai_cta_closed';

const FaiCTA = ({ ticker, page }) => {
    const [isClosed, setClosed] = useState(
        Boolean(window.localStorage.getItem(LOCAL_STORAGE_NAMESPACE))
    );
    const { experience } = useContext(ReactTargetContext);
    const label =
        ticker || humanFriendlyPageMap[page] || humanFriendlyPageMap.default;

    const faiURL = ticker ? getFundFAIUrl(ticker) : getPageFAIUrl(page);
    const institutionalURL = ticker
        ? getFundInstitutionalUrl(ticker)
        : getPageInstitutionalUrl(page);

    const shouldRender =
        !isClosed &&
        // Adding isLowerEnvironment logic to force the modal to appear in lower
        // environments where Target is not set up.
        // The test "will render two different things depending on experience"
        // was skipped to amke this work.
        (experience === 'usi_redirect' ||
            isLowerEnvironment(window.location.host)) &&
        Boolean(faiURL || institutionalURL);

    const closeCTA = () => {
        window.localStorage.setItem(LOCAL_STORAGE_NAMESPACE, true);
        setClosed(true);
    };

    return (
        shouldRender && (
            <div className="fai-cta" data-metrics-location="PU">
                <button
                    onClick={closeCTA}
                    aria-label="Close overlay."
                    name="close-btn"
                    id="fai-cta-close-btn"
                    type="button"
                >
                    Close
                </button>
                <strong>
                    Are you a {faiURL && 'financial professional'}
                    {institutionalURL && ' or institutional investor'}?
                </strong>
                <div>
                    View {label} on our&nbsp;
                    {faiURL && (
                        <a
                            aria-label="Go to Intermediaries page."
                            title={`${ticker || page} Intermediaries page`}
                            href={faiURL}
                        >
                            Intermediaries
                        </a>
                    )}
                    {institutionalURL && (
                        <React.Fragment>
                            &nbsp;or{' '}
                            <a
                                aria-label="Go to Institutional page."
                                title={`${ticker || page} Institutional page`}
                                href={institutionalURL}
                            >
                                Institutional
                            </a>
                        </React.Fragment>
                    )}{' '}
                    website.
                </div>
                <style jsx>{styles}</style>
            </div>
        )
    );
};

export default FaiCTA;
